var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 9.3c0 5.1-4.2 9.3-9.3 9.3-1.6 0-3.1-.4-4.5-1.2L0 19l1.7-5C.8 12.6.4 10.9.4 9.2.3 4.1 4.5 0 9.7 0S19 4.1 19 9.3zM9.7 1.5C5.3 1.5 1.8 5 1.8 9.3c0 1.6.5 3.2 1.5 4.6l-1 2.9 3-1c1.3.8 2.8 1.2 4.4 1.2 4.3 0 7.8-3.5 7.8-7.8 0-4.2-3.5-7.7-7.8-7.7zm4.7 9.9c-.1-.1-.2-.2-.4-.3-.2-.1-1.4-.7-1.6-.7-.2-.1-.4-.1-.5.1-.2.2-.6.7-.7.9-.1.2-.3.2-.5.1s-1-.4-1.8-1.1C8.1 9.7 7.7 9 7.5 8.7c-.1-.2 0-.4.1-.5.1 0 .3-.2.4-.3.1-.1.2-.2.2-.4.1-.2 0-.3 0-.4-.1-.1-.5-1.2-.7-1.7C7.3 5 7.1 5 7 5h-.5c-.1 0-.4.1-.6.3s-.8.8-.8 1.9.8 2.2.9 2.3c.2.2 1.6 2.6 4 3.5s2.3.6 2.7.6c.4 0 1.4-.5 1.5-1.1.2-.6.2-1 .2-1.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.bd525dd764d24fa5abbe9a92669356b0.svg";
export { ForwardRef as ReactComponent };